import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.COLLECTIONS_LIST, { params: payload }),
    search: payload => axios.get(HTTP.COLLECTIONS_SEARCH, { params: { ...payload } }),
    getCollection: payload => axios.get(HTTP.COLLECTION, { params: payload }),
    addCollection: payload => axios.post(HTTP.COLLECTION, payload),
    updateCollection: payload => axios.put(HTTP.COLLECTION, payload),
    deleteCollection: id => axios.delete(HTTP.COLLECTION, { params: { id } }),
    addCategory: payload => axios.post(HTTP.COLLECTION_CATEGORY, payload),
    deleteCategory: payload => axios.delete(HTTP.COLLECTION_CATEGORY, { params: payload }),
    addServiceField: payload => axios.post(HTTP.COLLECTION_SERVICEFIELD, payload),
    deleteServiceField: payload => axios.delete(HTTP.COLLECTION_SERVICEFIELD, { params: payload }),
    getTypes: () => axios.get(HTTP.COLLECTIONS_TYPES),
    updateUsageMode: payload => axios.patch(HTTP.COLLECTION, { payload })
}
